import React from 'react';
import { IHttpApi } from '@cian/http-api';
import { INotificationCenterData } from '../../../typings/window';
import { IDesktopGetNotificationsRequest } from '../../repositories/notification-center/v1/desktop-get-notifications';
import { INotificationForDesktopSchema } from '../../repositories/notification-center/entities/notification/NotificationForDesktopSchema';
import { NewChatsNotificator } from './Chat';
import { SearchesNotificator } from './Searches';
import { Compare } from './Compare';
import { Favorites } from '../Favorites';
import { IHeaderV1Schema } from '../../repositories/header/entities/response/HeaderV1Schema';
import { NotificationCenter } from '../NotificationCenter';
import {
  IWebGetUserFavoritesRequest,
  IWebGetUserFavoritesResponse,
} from '../../repositories/favorites/v1/web-get-user-favorites';
import { IApplicationState } from '../../types/state';

export interface IGroupIconsProps {
  httpApi?: IHttpApi;
  favLink: string;
  headerData: IHeaderV1Schema;
  baseUrl: string;
  newHeaderEnabled?: boolean;
  notificationCenterData: INotificationCenterData;
  getHasNewNotifications(): Promise<boolean>;
  getNotifications(parameters: IDesktopGetNotificationsRequest): Promise<INotificationForDesktopSchema[] | []>;
  markNotificationAsRead?(id: number): Promise<number | null>;
  markAllNotificationAsRead?(): Promise<void>;
  deleteAllNotifications?(): Promise<void>;
  getFavorites?(params: IWebGetUserFavoritesRequest): Promise<IWebGetUserFavoritesResponse | null>;
  section?: IApplicationState['section'];
}

export const GroupIcons: React.FC<IGroupIconsProps> = ({
  httpApi,
  favLink,
  getNotifications,
  getHasNewNotifications,
  markNotificationAsRead,
  markAllNotificationAsRead,
  deleteAllNotifications,
  getFavorites,
  headerData,
  baseUrl,
  notificationCenterData,
  newHeaderEnabled = false,
  section,
}) => {
  const isAuthenticated = headerData && headerData.isAuthenticated;
  const { isMobileDevice } = notificationCenterData;

  return (
    <React.Fragment>
      <div id="header-compare" className="c-header-messages group-icons">
        <Compare section={section} />
      </div>
      {isAuthenticated && (
        <div id="header-chats-icon-new" className="c-header-messages group-icons">
          <NewChatsNotificator headerData={headerData} baseUrl={baseUrl} notificationsCount={0} />
        </div>
      )}
      <div className="c-header-user-item group-icons" id="header-user-favourites">
        <Favorites favLink={favLink} getFavorites={getFavorites} />
      </div>
      {isAuthenticated && (
        <div id="header-user-searches" className="c-header-messages group-icons">
          <SearchesNotificator headerData={headerData} />
        </div>
      )}
      {!isMobileDevice && (
        <div className="c-header-messages group-icons c-header-notifications">
          <NotificationCenter
            newHeaderEnabled={newHeaderEnabled}
            httpApi={httpApi}
            notificationCenterData={notificationCenterData}
            getNotifications={getNotifications}
            getHasNewNotifications={getHasNewNotifications}
            markNotificationAsRead={markNotificationAsRead}
            markAllNotificationAsRead={markAllNotificationAsRead}
            deleteAllNotifications={deleteAllNotifications}
          />
        </div>
      )}
    </React.Fragment>
  );
};
